import {
  defineStore,
  IStoreState,
  useGetters,
  useState,
  useStore,
} from '~/utils/store'

import {
  OPT_HOME_APPLY_TYPE,
  EXTERNAL_HOME_LIST,
} from '~/constants/home'
import { getHomePageInfo } from '@/api/apply'
import log from '@/utils/log'
import { checkApplyType, checkCountry, checkCurrency, checkCurrencySymbol, checkHasUC, checkPage, checkProductInfo, checkUserFlag } from '@/utils/check/home'
import { setConfig } from '@didi/error-base'

const homeStore = defineStore({
  state: () => ({
    /**
     * 用户数据来源
     * 0 - none
     * 1 - minsait
     * 2 - didi
     * 3 - minsait&didi
     */
    userFlag: 1,
    /** 当前用户所处申卡流程
     * 0 - 无信息 1 - 500100普通申卡； 2 - 532PS0普通申卡； 3 - 532PS0预授信申卡
     * 注意：后端返回的的时候可能是-1可能是0
     */
    applyType: 0,
    /**
     * 上下文信息，后端使用，作为公参透传
     */
    contextInfo: {
      emailOccupationPre: false,//是否是新增邮箱和行业实验
      externalCurpOccupy:false , // 端外申卡兼容CURP占用流程灰度
    },
    /**
     * 是否现金贷UC用户
     */
    hasUC: false,
    /**
     * 是否二段式
     */
    cardSeparate: false,
    /**
     * 预授信标识
     */
    preCredit: false,
    /**
     * 首页枚举类型
     */
    homePageStatus: 0, // 首页类型
    /**
     * 页面类型 首页固定为homePage
     */
    page: '',
    /**
     * 端外首页信息
     */
    externalInfo: {
      retryDate: '',
      firstName: '',
    },
    /**
     * 首页数据初始化完成标识
     */
    initFlag: false,
  }),
  getters: {},
  actions: {
    async prepare(store, params) {
      let data: api_home_index.Response
      try {
        const res = await getHomePageInfo(params)
        data = res.data
      } catch (err) {
        console.error('err: ', err);
        log.error('getHomePageInfo_err', err)
        return
      }
      const {
        productFundsChannelInfo,
        currencySymbol,
        country,
        currency,
        uid,
        cfrnid,
        homePageStatus,
        ruid,
        cityId,
        userFlag,
        applyType,
        page,
        contextInfo,
        hasUC,
        externalInfo,
        test,
      } = data

      // 1、公参更新
      // 设置资方
      if (checkProductInfo(productFundsChannelInfo)) {
        store.commit(
          'vendor/saveVendor',
          productFundsChannelInfo,
          {
            root: true,
          }
        )
      } else {
        // 进错误重试页
        return
      }

      // 国家信息校验
      if (checkCountry(country)) {
        store.commit(
          'common/update',
          {
            country,
            cityId,
          },
          {
            root: true,
          }
        )
      } else {
        // 进错误重试页
        return
      }

      // 货币校验
      if (checkCurrency(currency)) {
        store.commit(
          'common/update',
          {
            currencyValue: currency,
          },
          {
            root: true,
          }
        )
      } else {
        return
      }

      // 货币符号校验
      if (checkCurrencySymbol(currencySymbol)) {
        store.commit(
          'common/update',
          {
            currency: currencySymbol,
          },
          {
            root: true,
          }
        )
      } else {
        return
      }

      // 设置用户id
      if (uid) {
        store.commit(
          'user/update',
          { uid },
          {
            root: true,
          }
        )
        setConfig({
          userId: uid as string
        })
      }

      // 设置用户cfrnid
      if (cfrnid) {
        store.commit(
          'user/update',
          { cfrnid },
          {
            root: true,
          }
        )
      }

      // 设置用户ruid
      if (ruid) {
        store.commit(
          'user/update',
          { ruid },
          {
            root: true,
          }
        )
      }

      // 设置用户数据来源
      if (checkUserFlag(userFlag)) {
        store.commit('saveUserFlag', userFlag)
      } else {
        return
      }

      // 设置端外首页信息 部分首页需要此信息
      store.commit('saveExternalInfo', externalInfo)

      // 设置首页标识
      store.commit('update', {
        homePageStatus,
      })

      // 更新apollo信息
      const {
        switch_age_barrier,
        fintech_fe_baldr_address_rule,
        fintech_fe_baldr_external_app_link_urls,
        fintech_baldr_grayscale_verification_eva,
        fintech_fe_baldr_download_button,
        fintech_fe_progress_bar_copywriting,
        switch_max_limt_outside,
      } = data
      if (switch_age_barrier) {
        useStore().commit('apollo/saveSwitchConf', {
          switch_age_barrier
        })
      }
      if (fintech_fe_baldr_address_rule) {
        useStore().commit('apollo/saveSwitchConf', {
          fintech_fe_baldr_address_rule
        })
      }
      if (fintech_fe_baldr_external_app_link_urls) {
        useStore().commit('apollo/saveSwitchConf', {
          fintech_fe_baldr_external_app_link_urls
        })
      }
      if (fintech_baldr_grayscale_verification_eva) {
        useStore().commit('apollo/saveABTestResult', {
          fintech_baldr_grayscale_verification_eva: {
            ...(fintech_baldr_grayscale_verification_eva as any).params,
          }
        })
      }

      if (fintech_fe_baldr_download_button) {
        useStore().commit('apollo/saveABTestResult', {
          fintech_fe_baldr_download_button: {
            ...(fintech_fe_baldr_download_button as any).params,
          }
        })
      }
      if (fintech_fe_progress_bar_copywriting) {
        useStore().commit('apollo/saveABTestResult', {
          fintech_fe_progress_bar_copywriting: {
            ...(fintech_fe_progress_bar_copywriting as any).params,
          }
        })
      }
      if (switch_max_limt_outside) {
        useStore().commit('apollo/saveSwitchConf', {
          switch_max_limt_outside
        })
      }



      // 设置埋点公参
      const { commonRcExt } = useGetters('rcext', [
        'commonRcExt',
      ])
      window?.Omega && window.Omega.setConfig(
        {
          userId: uid,
          attrs: {
            uid: uid,
            pub_uid: uid,
            test: test,
            cfrnid: cfrnid,
            product_id: productFundsChannelInfo?.productId,
            // 手机号
            login_mobile: useState('user', ['loginMobile'])[
              'loginMobile'
            ],
            // 白名单状态
            white_status: '',
            // 授信状态
            credit_status: '',
            // 重试状态
            retry_status: '',
            // 人审状态
            audit_status: '',
            //国际化金融业务线专用参数，fin只针对国际化金融业务线
            pub_biz_line: 'fin',
            //子业务：payment：支付、cashloan：现金贷 creditcard：信用卡
            pub_subbiz: 'creditcard',
            app_version: commonRcExt.appversion,
            phone_model: commonRcExt.model,
            operating_system: commonRcExt.os,
            mobile_service: commonRcExt.mobileService,
            app_store: commonRcExt.appStore,
          }
        }
      )

      // 2、根据首页类型更新数据
      // 更新申卡类首页基础信息
      if (homePageStatus === EXTERNAL_HOME_LIST.APPLY
      ) {
        // 设置申卡流程标识
        if (checkApplyType(applyType)) {
          store.commit('saveApplyType', applyType)
        } else {
          return
        }

        // 校验page 失败拦截
        if (checkPage(page)) {
          store.commit('update', {
            page,
          })
        } else {
          return
        }

        store.commit('update', {
          contextInfo,
          hasUC: checkHasUC(hasUC) ? hasUC : false, // 校验失败当作非UC用户
          cardSeparate: [
            OPT_HOME_APPLY_TYPE.vr_divide_precredit,
            OPT_HOME_APPLY_TYPE.vr_divide,
            OPT_HOME_APPLY_TYPE.curp_conflict_normal,
            OPT_HOME_APPLY_TYPE.curp_conflict_pre,
          ].includes(applyType),
        })
      }
      store.commit('saveInitialize', true)
    }
  },
  mutations: {
    saveInitialize(state, flag: boolean) {
      state.initFlag = flag
    },
    saveUserFlag(state, flag: number) {
      state.userFlag = flag
    },
    saveApplyType(state, applyType: number) {
      state.applyType = applyType
    },
    saveExternalInfo(state, data) {
      data && Object.assign(state.externalInfo, data)
    },
    update(state, data) {
      data && Object.assign(state, data)
    },
  },
})

export default homeStore
export type IHomeStoreState = IStoreState<
  typeof homeStore.state
>
